import type { date } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';

export const useTimezone = (): date.Timezone => {
  const ctxProps = useGlobalStateContextSelectors({
    timezone: prop('user', 'timezone'),
  });

  return ctxProps.timezone;
};
